import React, { useEffect, useState, useContext } from "react";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import TableCS from "../../components/TableCS";
import Alert from "../../components/Alert";
import APP from '../../tools/AppRoutes';
import { HISTORIAL } from "../../tools/ApiRoutes";
import formatDatetime from "../../tools/FormatDatetime";
import enviarPeticion from "../../tools/EnviarPeticion";
import Context from "../Master/SessionProvider";
import AutocompleteCS from "../../components/AutocompleteCS";
import DropDownListCS from "../../components/DropDownListCS";
import LabelCS from "../../components/LabelCS";
import { CSVLink } from "react-csv";

const Historial = ({history}) => {
    const { user, seleccionar } = useContext(Context);

    const [ alert , setAlert ] = useState({ msg: '', severity: 'success', open: false }); //MODAL NOTIFICACIONES
    const [ loading, setLoading ] = useState(true);
    const [ listaClientes, setListaClientes ] = useState([]);
    const [ listaAltasAC, setListaAltasAC ] = useState([]);
    const [ listaClientesTemp, setListaClientesTemp ] = useState([]);
    const [ estatusSeleccionado, setEstatusSeleccionado ] = useState('Todos');

    const columnasTabla = [
        { title: "Número Cliente", field: "NumeroCliente" },
        { title: "Razón Social", field: "RazonSocial" },
        { title: "NIT", field: "NIT"},
        { title: "Fecha Registro", field: "FechaRegistro", render: (row) => {
            return formatDatetime(row.FechaRegistro);
        }, },
        { title: "Estatus", field: "Estatus", cellStyle: (cellValue) => { 
            switch (cellValue){
                case 'Autorizada':
                    return {color: 'green'}
                default:
                    return {color: 'red'}
            }
          } },
        { title: "", render: (row) => {
            return(
                <>

                    <button onClick={(event) => { VerDetalle(event, row) }} style={{border: 'none', padding: '0', backgroundColor: 'inherit', color: 'blue'}}><span>Ver Detalle</span></button>
                </>
            )
        }},
        
    ];

    //ESTOS SON LOS HEADERS PARA EXPORTAR A EXCEL
    const headers = [
        {label: 'Número Cliente', key: 'NumeroCliente'},
        {label: 'Razón Social', key: 'RazonSocial'},
        {label: 'NIT', key: 'NIT'},
        {label: 'Dirección', key: 'Direccion'},
        {label: 'Teléfono', key: 'Telefono'},
        {label: 'Municipio', key: 'Municipio'},
        {label: 'Fecha Inicio Actividad', key: 'FechaInicioActividad'},
        {label: 'Fecha Registro', key: 'FechaRegistro'},
        {label: 'Nombre Contacto Comercial', key: 'NombreSolicitante'},
        {label: 'Email Contacto Comercial', key: 'EmailSolicitante'},
        {label: 'Teléfono Contacto Comercial', key: 'TelefonoSolicitante'},
        {label: 'Cargo en la Empresa', key: 'CargoDeSolicitante'},
        {label: 'Cómo se enteró', key: 'DondeConocioCompuSoluciones'}
    ];

     // Función para dar formato a la columna de fecha
     const formatoFecha = (Fecha) => {
        if (Fecha === null) return "";
        else {
            return new Date(Fecha).toISOString().slice(0, 10);}
    };

    // Crear una nueva matriz de datos con el formato aplicado a la columna de fecha
    const formattedData = listaClientesTemp.map((item) => ({
        ...item,
        FechaRegistro: formatoFecha(item.FechaRegistro),
        FechaInicioActividad: formatoFecha(item.FechaInicioActividad)
    }));

    const VerDetalle = (event, row) => {
        event.preventDefault();
        seleccionar(row);
        window.scrollTo(0,0);
        history.push(APP.DETALLEHISTORIAL);
    }

    //GUARDA LOS FILTROS SELECCIONADOS
    const filtrar = (prop) => (event) => {

        if (event.target.innerText !== ""){

            let copia;
            if (prop === 'Cliente'){
                copia = listaClientes.filter(item => item.RazonSocial.toLowerCase().includes(event.target.innerText.toLowerCase()));
            }
            else{
                if (event.target.value !== 'Todos'){
                    copia = listaClientes.filter(item => item.Estatus.toLowerCase().includes(event.target.value.toLowerCase()));
                }
                else{
                    copia = listaClientes;
                }

                setEstatusSeleccionado(event.target.value);
            }            

            setListaClientesTemp(copia);

            if (copia.length < 1) setAlert({ msg: 'No se encontraron resultados', severity: 'info', open: true });
        }
        else{
            setListaClientesTemp(listaClientes);
        }
    }



    //CIERRA MENSAJE DE VALIDACIÓN
    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });

    const llenarClientes = async () => {
        const config = {
            method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                }
        };

        const res = await enviarPeticion(config, HISTORIAL.Clientes);
        setListaClientes(res.data);
        return res.data;
    }

    const llenarListaFiltro = async () => {

        const config = {
            method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                }
        };

        const res = await enviarPeticion(config, `${HISTORIAL.ListaFiltro}?param=historial`);

        setListaAltasAC(res.data);
    }

    useEffect(() => {
        
        const inicio = async () =>{
            const data = await llenarClientes();
            setListaClientesTemp(data);
            await llenarListaFiltro();
            setLoading(false);
        }

        //VALIDAMOS LA SESIÓN
        if (user.Usuario === '' || user.Usuario === null || user.Usuario === undefined){
            history.push(APP.INDEX);
        }
        else{
            inicio();
        }

        return (() => {
            //console.log("");
        });

    }, []);

     return (<>
     <Helmet>
        <title>Historial Registros</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">

                    {
                        alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} segundos={alert.segundos ? alert.segundos : 6} closeAlert={closeAlert}/> : <></>
                    }

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Historial de Registros</label>
                    </div>
                    <br />
                    <br />

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            <AutocompleteCS items={listaAltasAC} placeholder='Buscar cliente...' fn={filtrar('Cliente')}></AutocompleteCS>
                            {/* <TextFieldCS id='txtRazonSocial' placeholder='Razón Social' value={buscar} onChange={handleBuscar}></TextFieldCS> */}
                        </div>
                        <div className="col-sm-2 col-md-2 col-lg-2" style={{textAlign: 'right'}}>
                            <LabelCS label='Estatus'></LabelCS>
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <DropDownListCS items={[{value: 'Todos'}, {value: 'Autorizada'}, {value: 'Rechazada'}]} default={estatusSeleccionado} onChange={filtrar('Estatus')}></DropDownListCS>
                        </div>
                                                
                    </div>
                    <br />
                    <br />

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <CSVLink data={formattedData}
                                headers={headers} 
                                filename='ClientesColombia.csv' 
                                className='csv-button'>
                                    Descargar Reporte
                                </CSVLink>
                            </div>
                        </div>
                        < br/>
                        < br/>

                    <TableCS
                        columns={columnasTabla}
                        data={listaClientesTemp}
                    />
                    <br />
                    <br />
                    <br />
                    <br />

                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(withRouter(Historial));